export const radii = {
  none: 0,
  xs: 2,
  sm: 4,
  chip: 6,
  md: 8,
  lg: 10,
  card: 10,
  panel: 12,
  pill: 999,
} as const;

export type RadiusToken = keyof typeof radii;

export const r = (token: RadiusToken): string => `${radii[token]}px`;
